export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/research_summaries.4dabd72.svg";